import React, { Component } from "react"

import Title from "../components/global/Title/Title"
import Button from "../components/global/Button/Button"
import Animation from "../components/global/Animation/Animation"

export default class NotFoundScreen extends Component {
  render() {
    return (
      <section className="relative p-0 pt-16">
        <Animation/>
        <div className="max-w-screen-xl mx-auto px-4 sm:px-6 md:flex md:flex-wrap lg:px-8 z-10 relative">
          <div className="ml-1-col w-3/4 pt-32 pb-8">
            <Title level="1" className="underlined">404 - Pagina niet gevonden</Title>
          </div>
          <div className="w-full md:mx-1-col">
            <Button className="mt-6" link="/">Terug naar de homepagina</Button>
          </div>
        </div>
      </section>
    )
  }
}
